import React from 'react';

interface H2TitleProps {
  isDarkTheme: boolean;
  children: React.ReactNode;
}

const H2Title: React.FC<H2TitleProps> = ({ isDarkTheme, children }) => {
  return (
    <div style={{ marginLeft: 40, marginRight: 40 }}>
      <h2>{children}</h2>
      <hr
        style={{
          height: 2,
          backgroundColor: isDarkTheme ? '#333333' : '#e0e0e0',
          border: 'none',
        }}
      />
    </div>
  );
};

export default H2Title;